import { createAction, props } from '@ngrx/store';
import { ReferralUser } from '@app/core/interfaces/user.interface';
import { SaveResult } from '@app/shared/interfaces/saveResult.interface';

export const LoadReferralAccountSettingsRequested = createAction(
  '[referralAccountSettings] Load Requested'
);

export const LoadReferralAccountSettingsSuccess = createAction(
  '[referralAccountSettings] Load Success',
  props<{ user: ReferralUser }>()
);

export const LoadReferralAccountSettingsFailure = createAction(
  '[referralAccountSettings] Load Failure',
  props<{ error: any }>()
);

export const UpdateReferralAccountSettingsRequested = createAction(
  '[referralAccountSettings] Update Requested',
  props<{ user: ReferralUser }>()
);

export const UpdateReferralAccountSettingsSuccess = createAction(
  '[referralAccountSettings] Update Success',
  props<{ result: SaveResult }>()
);

export const UpdateReferralAccountSettingsFailure = createAction(
  '[referralAccountSettings] Update Failure',
  props<{ error: any }>()
);
